export class HashTagReferenceModel {
    public hashTagId: string;
    public organisationId: string;
    public hashTagName: string;
    public statusCode: string;
}